import { Popconfirm, Tag, DatePicker, Input } from 'antd';
import Loader from 'components/loader';
import useUsers from 'hooks/useUsers';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { condicionesIva, states } from 'utils/Tables';
import { getNameFromObject } from 'utils/Utils';
import PublicationTable from '../publications/components/PublicationTable';
import PostulacionesTable from './components/PostulacionesTable';
import { useNavigate } from 'react-router-dom';
import { routesNames } from 'utils/Constants';
import { getCurriculumPDF } from "services/Usuarios"
import { getInstituciones } from "services/Reports"
import { getPublicationsByState } from "services/Publications"
import SectionTitle from "components/sectionTitle"
import { Card, Row, ActionButton } from "components/detailView"
import useNotification from 'hooks/useNotification';
import { BASE_API, SITE_URL } from "config/config"
import { FaFilePdf, FaHandshake } from "react-icons/fa";
import {
    MdEmail,
    MdPerson,
    MdWork,
    MdBusiness,
    MdLocationOn,
    MdContactPhone,
    MdInsights,
    MdCreditCard,
    MdHistory,
    MdBolt,
    MdAssignmentTurnedIn,
} from "react-icons/md";
import LogList from 'components/adminLogs/LogList';
import { getTree } from 'services/Especialidades';
import Asociaciones from 'components/asociaciones/Asociaciones';

const { TextArea } = Input
const dayjs = require('dayjs')

const formatDate = (value) => value ? new Date(value).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—";
const yesNo = (value) => value ? "Sí" : "No";


export default function ViewUser() {
    let { id } = useParams();
    let navigation = useNavigate()
    const { contextHolder, openNotification } = useNotification()

    const { isLoading, response, fetchData, verifyAccount, changePlan, changeVtoPlan } = useUsers()
    const [selectedPlan, setSelectedPlan] = useState(null)
    const [tree, setTree] = useState([])
    const [observacion, setObservacion] = useState('')
    const [vencimientoPlan, setVencimientoPlan] = useState(null)
    const [isLoadingPlan, setIsLoadingPlan] = useState(false)
    const [actividadInstitucion, setActividadInstitucion] = useState(null)
    const [ultimaPublicacion, setUltimaPublicacion] = useState(null)

    const disabledDate = (current) => {
        return current && current < dayjs().startOf('day');
    };

    const fetchPdf = async (userId) => {
        const data = await getCurriculumPDF(userId)

        if (data?.uuid) {
            window.open(`${BASE_API}cv/${data.filename}`, "_blank", "noreferrer");
        } else {
            openNotification('El curriculum se encuentra incompleto', 'success', 'Atención!')
        }
    }

    const onChange = (date) => {
        setVencimientoPlan(date.format('YYYY-MM-DD'));
    };

    const fetchTree = async () => {
        const treeResponse = await getTree()
        setTree(treeResponse)
    }

    const fetchActividadInstitucion = async (userId) => {
        const data = await getInstituciones()
        const rows = Array.isArray(data?.[0]) ? data[0] : []
        const match = rows.find((row) => String(row.user_id) === String(userId))
        setActividadInstitucion(match || null)
    }

    const fetchUltimaPublicacion = async (userId) => {
        const result = await getPublicationsByState({ userId })
        const rows = Object.values(result?.data || {}).filter((item) => item?.created_at)

        if (rows.length === 0) {
            setUltimaPublicacion(null)
            return
        }

        const latest = rows.reduce((max, item) => (new Date(item.created_at) > new Date(max.created_at) ? item : max), rows[0])
        setUltimaPublicacion(latest.created_at)
    }

    const saveLogs = async () => {
        const data = {
            user_id: response.id,
            vencimiento: vencimientoPlan,
            observacion: observacion
        }

        setIsLoadingPlan(true)
        await changeVtoPlan(data)
        setIsLoadingPlan(false)

        window.location.reload()
    }

    useEffect(() => {
        fetchData(id)
        fetchTree()
    }, [])

    useEffect(() => {
        if (response?.type === 'I' && response?.id) {
            fetchActividadInstitucion(response.id)
            fetchUltimaPublicacion(response.id)
        }
    }, [response?.type, response?.id])

    if (isLoading) {
        return <Loader />
    }

    const isInstitucion = response.type === "I"
    const isPostulante = response.type === "P"

    return (
        <div className='w-full'>
            {contextHolder}

            <div className='mb-5 flex flex-wrap items-center gap-2'>
                <h2 className="text-xl font-bold text-navy-700 dark:text-white">
                    {isInstitucion ? response?.cuenta?.nombre : response?.name}
                </h2>
                <Tag color={isInstitucion ? "lime" : "blue"}>{isInstitucion ? "Institución" : "Postulante"}</Tag>
                {response.cuenta?.verificado == 0 ? <Tag color="red">No verificada</Tag> : <Tag color="green">Verificada</Tag>}
                {response.cuenta?.activo == 0 ? <Tag color="red">Inactiva</Tag> : <Tag color="green">Activa</Tag>}
                {response.cuenta?.rechazado == 1 && <Tag color="red">Rechazada</Tag>}
                {response.cuenta?.suspendido == 1 && <Tag color="red">Suspendida</Tag>}
            </div>

            <div className="grid grid-cols-1 gap-5 xl:grid-cols-4">
                <div className="flex flex-col gap-5 xl:col-span-3">

                    {isPostulante && (
                        <div className="flex flex-col gap-8">
                            <div>
                                <SectionTitle eyebrow="Perfil del postulante">Datos del postulante</SectionTitle>
                                <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 items-start">
                                    <Card title="Datos personales" icon={<MdPerson size={20} />}>
                                        <Row label="DNI" value={response?.cuenta?.dni} />
                                        <Row label="Fecha de nacimiento" value={formatDate(response?.cuenta?.fecha_nac)} />
                                        <Row label="Sexo" value={response?.cuenta?.sexo == 'M' ? "Masculino" : "Femenino"} />
                                        <Row label="Estado civil" value={response?.cuenta?.estado_civil || "No informado"} />
                                        <Row label="Localidad" value={response?.cuenta?.localidad} />
                                        <Row label="Provincia" value={getNameFromObject(states, response?.cuenta?.provincia)} />
                                    </Card>

                                    <Card title="Contacto" icon={<MdEmail size={20} />}>
                                        <Row label="Email" value={response?.email} />
                                        <Row label="Teléfono" value={response?.cuenta?.telefono} />
                                        <Row label="Última sesión" value={formatDate(response?.last_login_at)} />
                                        <Row label="Cuenta creada" value={formatDate(response?.cuenta?.created_at)} />
                                        <Row label="Última actualización" value={formatDate(response?.cuenta?.updated_at)} />
                                        <Row label="IA disponible" value={yesNo(response?.cuenta?.disponible_ia)} />
                                    </Card>
                                </div>
                            </div>

                            <div>
                                <SectionTitle eyebrow="Perfil profesional">Perfil y CV</SectionTitle>
                                <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 items-start">
                                    <Card title="Especialidad y disponibilidad" icon={<MdWork size={20} />}>
                                        <Row label="Especialidad" value={tree?.tree?.tag?.[parseInt(response?.cuenta?.especialidad)]} />
                                        <Row label="Disponible para suplencias" value={yesNo(response?.cuenta?.disponible_suplencias)} />
                                        <Row label="Perfil público" value={yesNo(response?.cuenta?.perfil_publico)} />
                                    </Card>

                                    <Card title="Estado del CV" icon={<MdAssignmentTurnedIn size={20} />}>
                                        <Row label="CV completo" value={response?.cuenta?.fecha_perfil_completo ? `Sí (${formatDate(response.cuenta.fecha_perfil_completo)})` : "No"} />
                                    </Card>
                                </div>
                            </div>

                            <div>
                                <SectionTitle eyebrow="Postulaciones">Actividad</SectionTitle>
                                <PostulacionesTable userId={response.id} />
                            </div>
                        </div>
                    )}

                    {isInstitucion && (
                        <div className="flex flex-col gap-8">
                            <div>
                                <SectionTitle eyebrow="Perfil institucional">Datos de la institución</SectionTitle>
                                <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 items-start">
                                    <Card title="Datos básicos" icon={<MdBusiness size={20} />}>
                                        <Row label="Nombre" value={response?.cuenta?.nombre} />
                                        <Row label="CUIT" value={response?.cuenta?.cuit} />
                                        <Row label="Domicilio" value={response?.cuenta?.domicilio} />
                                        <Row label="Ubicación" value={`${response?.cuenta?.localidad || ""}, ${getNameFromObject(states, response?.cuenta?.provincia)} (CP ${response?.cuenta?.cp || "-"})`} />
                                        <Row label="Sitio web" value={response?.cuenta?.sitio_web ? <a href={response.cuenta.sitio_web} target='_blank' rel='noreferrer' className="text-blue-700">{response.cuenta.sitio_web}</a> : "—"} />
                                        <Row label="Cantidad de empleados" value={response?.cuenta?.empleados} />
                                        <Row label="IA disponible" value={yesNo(response?.cuenta?.disponible_ia)} />
                                    </Card>

                                    <div className="flex flex-col gap-5">
                                        <Card title="Datos de contacto" icon={<MdContactPhone size={20} />}>
                                            <Row label="Email" value={response?.email} />
                                            <Row label="Teléfono del responsable" value={response?.cuenta?.responsable_telefono} />
                                            <Row label="Responsable" value={response?.cuenta?.responsable_nombre} />
                                            <Row label="Documento del responsable" value={response?.cuenta?.responsable_documento} />

                                            {response.responsables?.length > 0 && (
                                                <div className="sm:col-span-2 mt-2 flex flex-col gap-2 border-t border-gray-100 pt-4 dark:border-navy-700">
                                                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Otros responsables</p>
                                                    {response.responsables.map((item, idx) => (
                                                        <Row key={idx} full label={item.position || "Responsable"} value={`${item.name} · ${item.email}`} />
                                                    ))}
                                                </div>
                                            )}
                                        </Card>

                                        {response.ubicaciones?.length > 0 && (
                                            <Card title="Ubicaciones" icon={<MdLocationOn size={20} />}>
                                                {response.ubicaciones.map((item, idx) => (
                                                    <div key={idx} className="sm:col-span-2 border-b border-gray-100 pb-2 last:border-none dark:border-navy-700">
                                                        <p className="text-sm font-semibold text-navy-700 dark:text-white">
                                                            {item.nombre || item.localidad || "Ubicación"}
                                                        </p>
                                                        <p className="text-xs text-gray-600 dark:text-gray-400">
                                                            {item.calle} {item.numero}, {item.localidad}, {getNameFromObject(states, item.provincia)} ({item.codigo_postal})
                                                        </p>
                                                        {(item.razon_social || item.cuit) && (
                                                            <p className="text-xs text-gray-500 dark:text-gray-500">
                                                                {item.razon_social} {item.cuit && `· CUIT ${item.cuit}`} {item.condicion_iva ? `· ${getNameFromObject(condicionesIva, item.condicion_iva)}` : ""}
                                                            </p>
                                                        )}
                                                    </div>
                                                ))}
                                            </Card>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div>
                                <SectionTitle eyebrow="Uso de la plataforma">Actividad</SectionTitle>
                                <div className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm dark:border-navy-700 dark:bg-navy-800">
                                    <div className="grid grid-cols-1 gap-6 divide-y divide-gray-100 sm:grid-cols-3 sm:divide-x sm:divide-y-0 dark:divide-navy-700">
                                        <div className="flex flex-col gap-3 sm:pr-6">
                                            <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                                                <MdWork /> Publicaciones
                                            </p>
                                            <Row label="Publicaciones totales" value={actividadInstitucion?.publicaciones_count} />
                                            <Row label="Publicaciones activas" value={actividadInstitucion?.publicaciones_activas_count} />
                                        </div>
                                        <div className="flex flex-col gap-3 pt-6 sm:pt-0 sm:px-6">
                                            <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                                                <MdInsights /> Postulaciones y especialidades
                                            </p>
                                            <Row label="Postulaciones recibidas" value={actividadInstitucion?.postulaciones_count} />
                                            <Row label="Especialidades publicadas" value={actividadInstitucion?.especialidades_list} />
                                        </div>
                                        <div className="flex flex-col gap-3 pt-6 sm:pt-0 sm:pl-6">
                                            <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                                                <MdBolt /> Actividad
                                            </p>
                                            <Row label="Última sesión" value={formatDate(response?.last_login_at)} />
                                            <Row label="Última publicación" value={formatDate(ultimaPublicacion)} />
                                            <Row label="Cuenta creada" value={formatDate(response?.cuenta?.created_at)} />
                                            <Row label="Última actualización" value={formatDate(response?.cuenta?.updated_at)} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <SectionTitle eyebrow="Plan y comunidad">Suscripción</SectionTitle>
                                <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 items-start">
                                    <Card
                                        title={
                                            <>
                                                Plan
                                                <Tag color={response.plan?.detalle?.nombre === 'Gold' ? "gold" : "purple"}>
                                                    {response.plan?.detalle?.nombre || "Standard"}
                                                </Tag>
                                            </>
                                        }
                                        icon={<MdCreditCard size={20} />}
                                    >
                                        {response.plan?.detalle?.nombre === 'Gold' && (
                                            <Row label="Vence el" value={dayjs(response.plan?.vencimiento).format('DD/MM/YYYY')} />
                                        )}

                                        <div className="sm:col-span-2 flex flex-col gap-2 border-t border-gray-100 pt-4 dark:border-navy-700">
                                            <span className='text-sm font-semibold text-navy-700 dark:text-white'>Cambiar Plan</span>
                                            <div className="flex flex-wrap items-center gap-2">
                                                <select
                                                    onChange={(e) => setSelectedPlan(e.target.value)}
                                                    className='rounded-lg border py-1 pl-2 w-[200px] dark:bg-navy-700'
                                                >
                                                    <option>Seleccionar nuevo plan</option>
                                                    {response.planes?.map((plan, idx) => (
                                                        <option key={idx} value={plan.id}>{plan.nombre}</option>
                                                    ))}
                                                </select>

                                                <Popconfirm
                                                    title="Cambiar plan"
                                                    description="¿Está seguro que desea cambiar el plan del usuario?"
                                                    onConfirm={async () => {
                                                        if (selectedPlan) {
                                                            await changePlan(response.id, selectedPlan)
                                                            window.location.reload()
                                                        }
                                                    }}
                                                    okText="Si"
                                                    cancelText="No"
                                                    okButtonProps={{ className: "bg-blue-500" }}
                                                >
                                                    <button className='rounded-md bg-aprobado px-4 py-1 text-sm text-white'>Cambiar plan</button>
                                                </Popconfirm>
                                            </div>
                                        </div>

                                        {response.plan?.detalle?.nombre === 'Gold' && (
                                            <div className='sm:col-span-2 flex flex-col gap-2'>
                                                <span className='mt-2 text-sm font-semibold text-navy-700 dark:text-white'>Vencimiento del plan gold</span>
                                                <DatePicker
                                                    onChange={onChange}
                                                    className='h-10 w-full'
                                                    format={'DD/MM/YYYY'}
                                                    defaultValue={response.plan?.vencimiento ? dayjs(response.plan?.vencimiento) : dayjs()}
                                                    disabledDate={disabledDate}
                                                />
                                                <TextArea
                                                    name="observacion"
                                                    placeholder='Observaciones'
                                                    rows={3}
                                                    onChange={(e) => setObservacion(e.target.value)}
                                                />
                                                {isLoadingPlan ? <Loader /> : (
                                                    <button className='rounded-md bg-aprobado px-4 py-1 text-sm text-white' onClick={saveLogs}>Guardar datos</button>
                                                )}
                                            </div>
                                        )}
                                    </Card>

                                    <Card title="Historial de cambios" icon={<MdHistory size={20} />}>
                                        <div className="sm:col-span-2">
                                            {response?.changeLogs?.length > 0 ? (
                                                <LogList className='w-full' logs={response?.changeLogs} />
                                            ) : (
                                                <p className="text-sm text-gray-500 dark:text-gray-400">Sin movimientos de plan registrados</p>
                                            )}
                                        </div>
                                    </Card>

                                    {response.facturacion?.length > 0 && (
                                        <Card title="Datos de facturación" icon={<MdCreditCard size={20} />}>
                                            {response.facturacion.map((item, idx) => (
                                                <div key={idx} className="sm:col-span-2 flex flex-col gap-1 border-b border-gray-100 pb-3 last:border-none dark:border-navy-700">
                                                    {Object.entries(item)
                                                        .filter(([key]) => !["id", "user_id"].includes(key))
                                                        .map(([key, value]) => (
                                                            <p key={key} className="text-xs text-gray-600 dark:text-gray-400">
                                                                <span className="font-semibold capitalize text-navy-700 dark:text-white">{key.replace(/_/g, " ")}:</span> {String(value ?? "—")}
                                                            </p>
                                                        ))}
                                                </div>
                                            ))}
                                        </Card>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {isInstitucion && (
                        <Card title="Asociación" icon={<FaHandshake size={18} />}>
                            <div className="sm:col-span-2">
                                <Asociaciones defaultValue={response?.cuenta?.asociacion_id} cuenta={response?.cuenta?.id} />
                            </div>
                        </Card>
                    )}
                </div>

                <div className="xl:col-span-1">
                    <div className="sticky top-[90px] mt-[60px] flex flex-col gap-2 rounded-2xl border border-gray-100 bg-white p-5 shadow-sm dark:border-navy-700 dark:bg-navy-800">
                        <h3 className="mb-2 flex items-center gap-2 text-base font-bold text-navy-700 dark:text-white">
                            <MdBolt className="text-gray-600 dark:text-gray-300" size={20} /> Acciones
                        </h3>

                        <a target='_blank' rel='noopener noreferrer' href={`${SITE_URL}loginAsUser?uuid=${response?.uuid}&type=${response?.type}`}>
                            <ActionButton color="green">Ingresar como usuario</ActionButton>
                        </a>

                        {isPostulante && (
                            <ActionButton color="red" onClick={() => fetchPdf(response?.id)}>
                                <span className="flex items-center justify-center gap-2"><FaFilePdf /> Descargar CV</span>
                            </ActionButton>
                        )}

                        {isPostulante && (
                            <a target='_blank' rel='noopener noreferrer' href={`${SITE_URL}cv/${response.uuid}`}>
                                <ActionButton color="navy">Ver currículum</ActionButton>
                            </a>
                        )}

                        {response.cuenta?.verificado == 0 && (
                            <Popconfirm
                                title="Verificar cuenta"
                                description="¿Está seguro que desea confirmar la verificación de la cuenta?"
                                onConfirm={async () => {
                                    await verifyAccount(response.id, { verificado: 1, tipo: response.type })
                                    window.location.reload()
                                }}
                                okText="Si"
                                cancelText="No"
                                okButtonProps={{ className: "bg-blue-500" }}
                            >
                                <ActionButton color="green">Verificar cuenta</ActionButton>
                            </Popconfirm>
                        )}

                        {response.cuenta?.verificado == 0 && response.cuenta?.activo == 0 && (
                            <Popconfirm
                                title="Verificar y activar cuenta"
                                description="¿Está seguro que desea confirmar la verificación y la activación de la cuenta?"
                                onConfirm={async () => {
                                    await verifyAccount(response.id, { verificado: 1, activo: 1, tipo: response.type })
                                    window.location.reload()
                                }}
                                okText="Si"
                                cancelText="No"
                                okButtonProps={{ className: "bg-blue-500" }}
                            >
                                <ActionButton color="green">Verificar y activar cuenta</ActionButton>
                            </Popconfirm>
                        )}

                        {response.cuenta?.verificado == 1 && response.cuenta?.activo == 0 && (
                            <Popconfirm
                                title="Activar cuenta"
                                description="¿Está seguro que desea confirmar la activación de la cuenta?"
                                onConfirm={async () => {
                                    await verifyAccount(response.id, { activo: 1, tipo: response.type })
                                    window.location.reload()
                                }}
                                okText="Si"
                                cancelText="No"
                                okButtonProps={{ className: "bg-blue-500" }}
                            >
                                <ActionButton color="green">Activar cuenta</ActionButton>
                            </Popconfirm>
                        )}

                        {response.cuenta?.rechazado == 0 && (
                            <Popconfirm
                                title="Rechazar cuenta"
                                description="¿Está seguro que desea rechazar la cuenta?"
                                onConfirm={async () => {
                                    await verifyAccount(response.id, { rechazado: 1, tipo: response.type })
                                    if (response.type == 'P') {
                                        navigation(routesNames.POSTULANTES)
                                    } else if (response.type == 'I') {
                                        navigation(routesNames.INSTITUCIONES)
                                    } else {
                                        navigation(routesNames.USERS)
                                    }
                                }}
                                okText="Si"
                                cancelText="No"
                                okButtonProps={{ className: "bg-blue-500" }}
                            >
                                <ActionButton color="red">Rechazar cuenta</ActionButton>
                            </Popconfirm>
                        )}

                        {response.cuenta?.suspendido == 0 && (
                            <Popconfirm
                                title="Suspender cuenta"
                                description="¿Está seguro que desea suspender la cuenta?"
                                onConfirm={async () => {
                                    await verifyAccount(response.id, { suspendido: 1, tipo: response.type })
                                    window.location.reload()
                                }}
                                okText="Si"
                                cancelText="No"
                                okButtonProps={{ className: "bg-blue-500" }}
                            >
                                <ActionButton color="orange">Suspender cuenta</ActionButton>
                            </Popconfirm>
                        )}
                    </div>
                </div>
            </div>

            {isInstitucion && (
                <div className="mt-8">
                    <span className='mb-2 block text-base font-semibold text-navy-700 dark:text-white'>Publicaciones</span>
                    <PublicationTable user={response.id} />
                </div>
            )}
        </div>
    )
}
